import * as React from 'react';
import classnames from 'classnames';

import IconFavorite from './IconFavorite';

const styles = require('./IconFavorite.scss');

interface Props {
    initialIsFavorite: boolean;
    // function that returns a promise that resolves
    // with the target state if
    handleClick: (target: boolean) => Promise<boolean>;
    hideText?: boolean;
}

interface State {
    isFavorite: boolean;
    isUpdating: boolean;
}

export default class IconFavoriteContainer extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.tryToggle = this.tryToggle.bind(this);
        this.setIsUpdating = this.setIsUpdating.bind(this);
    }

    readonly state = {
        isFavorite: this.props.initialIsFavorite,
        isUpdating: false,
    };

    componentWillReceiveProps(nextProps: Props) {
        this.setState({
            isFavorite: nextProps.initialIsFavorite,
            isUpdating: false,
        });
    }

    public render() {
        return (
            <IconFavorite
                onClick={this.tryToggle}
                isFavorite={this.state.isFavorite}
                isUpdating={this.state.isUpdating}
                hideText={this.props.hideText}
            />
        );
    }

    private tryToggle() {
        this.setIsUpdating(true);
        // Set a timeout to give the animation some time to run
        setTimeout(() => {
            this.props
                .handleClick(!this.state.isFavorite)
                .then((result) => {
                    this.setState({ isFavorite: result });
                    this.setIsUpdating(false);
                })
                .catch((_) => {
                    this.setIsUpdating(false);
                });
        }, 600);
    }

    private setIsUpdating(updating: boolean) {
        this.setState({ isUpdating: updating });
    }
}
